<template>
  <div>
    <div v-if="item">
      <h4>ID: {{ item.id }}</h4>
      <fields-list :item="item" :fields="fields" />
      <div class="save-panel">
        <button class="btn  btn-warning btn-icon" @click="updateItem">
          <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data() {
    return {
      cardLink: "business/clients",
      cardSetLink: "business/clients",
      item: null,
      bid: null,
      fields: [
        {
          key: "phone",
          label: "Номер телефона",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          col: 'col-12 col-md-6',
          key: "last_name",
          label: "Фамилия",
          type: "field",
          textType: "text",
        },
        {
          col: 'col-12 col-md-6',
          key: "first_name",
          label: "Имя",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          col: 'col-12 col-md-6',
          key: "father_name",
          label: "Отчество",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          col: 'col-12 col-md-6',
          key: "birthday",
          label: "Дата рождения",
          textType: "date",
          type: "field",
        },
      ],
      groupFields: [
        {
          col: "col-12 col-md-6",
          key: "school_from",
          label: "Учебный год прибытия",
          // type: "seasonField",
          type: "text",
          textType: "text",
          obj: "admission",
        },
        {
          col: "col-12 col-md-6",
          key: "region_from",
          label: "Откуда прибыл",
          type: "field",
          textType: "text",
          obj: "admission",
        },
        {
          col: "col-12 col-md-6",
          label: "Дата приказа о зачислении",
          key: "admission_order_date",
          textType: "date",
          // type: "date",
          type: "field",
          obj: "admission",
        },
        {
          col: "col-12 col-md-6",
          key: "admission_order_number",
          label: "Номер приказа",
          type: "field",
          textType: "text",
          obj: "admission",
        },
      ]
    }
  },
  props: ["id"],
  async created() {
    this.bid = this.$store.state.business.id
    let query = Object.assign({}, this.$route.query);
    if(query.item_group && query.item_client){
      this.cardLink = `${process.env.HOST_URL}/api/v3/schools/${this.bid}/classes/${query.item_group}/students`
      this.cardSetLink = `${process.env.HOST_URL}/api/v3/schools/${this.bid}/classes/${query.item_group}/students`
      this.fields = [...this.fields, ...this.groupFields]
    }
    console.log(this.cardLink, 'cardLink', this.$store.state.business.id, this.bid)
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
